import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MoodProvider } from './contexts/MoodContext';
import DailyView from './pages/DailyView';
import WeeklyView from './pages/WeeklyView';
import MonthlyView from './pages/MonthlyView';
import SettingsView from './pages/SettingsView';
import LandingPage from './components/LandingPage';
import InstallPrompt from './components/InstallPrompt';

function App() {
  const skipLanding = localStorage.getItem('skipLanding') === 'true';
  const initialRoute = skipLanding ? '/day' : '/welcome';

  return (
    <MoodProvider>
      <Router>
        <Routes>
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/day" element={<DailyView />} />
          <Route path="/week" element={<WeeklyView />} />
          <Route path="/month" element={<MonthlyView />} />
          <Route path="/settings" element={<SettingsView />} />
          <Route path="/" element={<Navigate to={initialRoute} replace />} />
          <Route path="*" element={<Navigate to={initialRoute} replace />} />
        </Routes>
        <InstallPrompt />
      </Router>
    </MoodProvider>
  );
}

export default App;